export default __webpack_public_path__ + "static/media/catering_jt.1db061f8.webp";